export { default } from './bitrix-documents';
